<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="headline orange white">
          <span style="color: white">Session Timeout</span>
        </v-card-title>
        <v-card-text class="pt-4">
          You have been inactive. You will be logged out in
          <strong>{{ countdown }}</strong> second{{ countdown !== 1 ? 's' : '' }}.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onStayLoggedIn">Stay Logged In</v-btn>
          <v-btn color="error" text @click="onLogoutNow">Logout Now</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { WARNING_BEFORE } from "../../utils/idleTimer";
const WARNING_SECONDS = WARNING_BEFORE / 1000;

export default {
  props: {
    visible: Boolean,
  },

  data() {
    return {
      dialog: false,
      countdown: WARNING_SECONDS,
      countdownInterval: null,
    };
  },

  watch: {
    visible(val) {
      this.dialog = val;
      if (val) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    },
  },

  methods: {
    startCountdown() {
      this.countdown = WARNING_SECONDS;
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) this.stopCountdown();
      }, 1000);
    },

    stopCountdown() {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    },

    onStayLoggedIn() {
      this.stopCountdown();
      this.$emit('stay');
    },

    onLogoutNow() {
      this.stopCountdown();
      this.$emit('logout');
    },
  },

  beforeDestroy() {
    this.stopCountdown();
  },
};
</script>
